import React, { useMemo } from "react";
import { PillsGroup } from "@gpstrackit/gtc-react-controls";
import { useIntl } from "react-intl";
import styles from "Assets/sass/core/vars.scss";

const StatusFilter = ({
  selectedStatus,
    onChange
}) => {
  const { messages, locale } = useIntl();

  const statusList = useMemo(() => {
    return [
      { id: -1, label: messages["all"], color: styles.black },
      {
        id: "Scheduled",
        label: messages["vehicleView_scheduledStatus"],
        color: styles.green,
      },
      {
        id: "PastDue",
        label: messages["vehicleView_pastDue"],
        color: styles.purple,
      },
      {
        id: "Due",
        label: messages["vehicleView_dueStatus"],
        color: styles.red,
      },
      {
        id: "DueSoon",
        label: messages["vehicleView_dueSoonStatus"],
        color: styles.orange,
      },
      {
        id: "Done",
        label: messages["vehicleView_done"],
        color: styles.black,
      },
    ];
  }, [locale]);

  return (
    <PillsGroup
      label={messages["vehicleView_maintenanceStatus"]}
      options={statusList}
      values={statusList && statusList.filter((x) => (selectedStatus || []).includes(x.id))}
      colorField="color"
      onChange={onChange}
      multicolor
      multiple
    />
  );
};

export default StatusFilter;